import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { loginWithToken } from './redux/actions';

export function useAutoLogin() {
    const location = useLocation();
    const dispatch = useDispatch()
    const { uuid } = useSelector(state => state.Member.authModal);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");

        if (token) {
            dispatch(loginWithToken(token))

            const newSearch = params.toString();
            // navigate({
            //     pathname: location.pathname,
            //     search: newSearch ? `?${newSearch}` : "",
            //     hash: location.hash,
            // }, { replace: true });
        }
    }, [location]);
}
